import client from "./client";

export const listStaff = async () => (await client.get("/platform/staff")).data;

export const inviteStaff = async (payload) => (await client.post("/platform/staff", payload)).data;

export const resendStaff = async (id) => (await client.post(`/platform/staff/${id}/resend`)).data;

export const removeStaff = (id) => client.delete(`/platform/staff/${id}`);
